import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Fragment } from "react";

const Body = () => (
  <div className="font-mukta flex justify-center">
    <div className="w-4/5">
      <h1 className="text-4.5xl font-semibold w-full text-left my-10">
        PRIVACY POLICY
      </h1>
      <p className="text-base text-textshade text-justify">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Tristique sed
        velit libero lectus sed netus amet. Iaculis tincidunt ac sed
        pellentesque. Erat eget cursus etiam amet tempus egestas ac diam ut.
        Orci, euismod duis magna dictum sed nisi eu cursus ac. Velit turpis
        consectetur sed at sagittis. Ut ac faucibus facilisis donec rhoncus quis
        nunc a nullam. Tristique lobortis vitae non suspendisse turpis porta
        velit eget consequat. Volutpat congue imperdiet accumsan quis
        scelerisque tempor neque. Tristique est elementum purus leo quam nunc
        ullamcorper. Facilisi volutpat duis risus scelerisque in elit in
        egestas. Et non neque, lacus risus, volutpat. Scelerisque pretium,
        semper varius mauris nec purus. Vitae, lectus congue mi est vulputate
        urna. Adipiscing faucibus eu nullam fringilla leo. Ut nisi et sodales
        sit arcu. Orci lectus non ac arcu scelerisque. Sit sagittis nec
        tristique integer pellentesque commodo augue turpis morbi. Semper sed
        blandit malesuada risus, elementum enim, nisl. Integer sit quisque
        tortor arcu morbi at. Egestas integer diam et nibh. Varius pellentesque
        fames molestie vivamus vehicula at varius eu at. Feugiat ut lacus,
        rhoncus amet. Nisl commodo nibh sed nulla. Nullam commodo diam ultrices
        ultrices phasellus posuere quis quis. Odio aliquam imperdiet libero
        etiam justo tempor ut diam, sed. A id at nulla sed mauris sagittis
        platea. Facilisis porttitor eleifend pellentesque pharetra fermentum sit
        facilisis arcu integer. A, tellus, vivamus a viverra gravida ornare eu
        fermentum curabitur. A ante faucibus in turpis nibh enim. Ultricies amet
        sit ac, in purus vitae condimentum posuere. Felis dui mauris, gravida
        lectus at. Ultricies malesuada proin convallis suspendisse amet pulvinar
        cras vel arcu. Convallis scelerisque risus, malesuada bibendum viverra
        et. Pulvinar duis tortor integer aliquet. Placerat viverra nibh ac
        fringilla. Cras sagittis nisl sagittis, nisl eu nulla urna. Donec
        ullamcorper sed dui accumsan ut malesuada. Sociis in placerat volutpat
        orci posuere praesent. A in ultrices ante in tortor. Et nulla ultricies
        aliquam lacus. In orci, viverra nisl, in tellus aliquam eget. Aliquam
        vitae tellus, nunc felis convallis. Purus sit orci posuere nunc, feugiat
        venenatis molestie cras. Ac aenean lobortis et nunc eget fusce quisque
        tellus. Quam lectus viverra turpis tincidunt. Diam cursus ornare
        faucibus augue tempus, senectus sed. Id pulvinar tincidunt mattis orci
        ut erat. Consectetur feugiat pretium gravida ligula lectus sit facilisi
        donec ut. Morbi et ornare nisi enim amet quis. Dictum viverra mi quisque
        sit id. Neque penatibus tempus ornare sapien a phasellus. At id vel nunc
        volutpat nullam. Morbi gravida tristique aliquet egestas congue sapien,
        elit odio pharetra. Sit nibh in pretium amet id imperdiet quisque
        adipiscing sit. Et auctor tortor aliquet adipiscing egestas. Faucibus
        nibh vel ultricies curabitur. Lacus, egestas eget vestibulum, interdum
        est amet et risus sed. Laoreet viverra ut adipiscing quam. Feugiat
        faucibus adipiscing tellus et, eget morbi vitae. Tellus porttitor enim
        quis lectus elit, urna adipiscing imperdiet fusce. Condimentum
        pellentesque neque ultrices placerat euismod euismod neque orci.
        Vehicula eget iaculis amet, nisl, gravida ultricies viverra. Tristique
        proin ornare non in. Risus morbi urna aliquam diam nec. Blandit volutpat
        neque pretium ultricies donec. Cursus dolor sit arcu, ultricies quam
        nulla pulvinar a. Viverra eros, dapibus volutpat tempus elementum,
        mattis id commodo sem. Senectus cras ut purus ipsum pellentesque sed
        urna. Amet neque malesuada aliquet tortor dui, egestas in. Massa
        bibendum velit lacus, viverra erat id felis. Quis turpis morbi viverra
        convallis adipiscing enim. Leo, viverra turpis eleifend tristique porta
        nibh aliquam, non quisque. Sem sit accumsan ac nisl mi dui etiam massa.
        Et netus purus velit lacinia sagittis dolor viverra sollicitudin a.
        Accumsan quis ac orci sed. Odio fusce vitae eget ac cursus fringilla
        cursus consectetur dui. Volutpat suspendisse mauris semper placerat.
        Adipiscing rutrum eget aliquam enim facilisi massa est condimentum
        pulvinar. Phasellus leo faucibus sit id. Nunc egestas tempor elementum
        sociis gravida placerat. Vitae orci, etiam molestie suscipit vestibulum
        quis. Egestas sit blandit senectus sit penatibus fusce amet, rutrum.
        Potenti ipsum turpis ut aliquet lacus. Aliquam faucibus posuere varius
        dui aliquet fermentum dictumst in. Molestie nibh ut sit orci. Vel aenean
        diam, nec non adipiscing diam vulputate urna. Consectetur scelerisque in
        vulputate sem mauris, non. Diam non ipsum scelerisque nunc, a, iaculis
        maecenas. Integer morbi eget sed augue tellus, placerat lorem et proin.
        Arcu ornare sit ullamcorper nunc adipiscing sodales. Ac viverra
        facilisis mi leo tincidunt scelerisque malesuada semper. Imperdiet
        mattis sollicitudin pretium interdum purus eu, magna at. Ante odio sed
        quis at imperdiet aliquam ut laoreet odio. Cursus elit id molestie
        nullam. At tincidunt mus elit, mus quis eget etiam. Non leo congue in
        pulvinar. Varius auctor rhoncus urna mattis. Egestas sagittis vitae
        elementum, et, eget a suspendisse tristique. Praesent vitae sed
        ridiculus sit erat malesuada. Tortor, ornare cursus nibh elementum.
        Tempor enim faucibus quis adipiscing ultrices. Congue lorem faucibus
        interdum non aliquet varius. Eget enim, praesent convallis sit feugiat
        fermentum orci arcu. Libero sed tortor, proin pretium, molestie
        vulputate sit accumsan. Imperdiet ut tempor mauris, consectetur. Quis
        gravida sed mauris pellentesque a at nec placerat nisl. Condimentum in
        mauris mauris pharetra mus ultrices. Scelerisque nisl nec nec, convallis
        viverra. Congue id dis fringilla laoreet rutrum in ut enim. Etiam congue
        vitae libero nunc ut aliquam id feugiat. Sem mauris dui tristique
        pretium et congue tempus nunc. Lectus nibh est id congue faucibus
        volutpat fermentum sed porta. Venenatis varius tellus, tristique enim,
        orci sit ultrices ornare commodo. Est, mauris vulputate massa donec
        molestie orci. Eu ultrices nisi sit et malesuada venenatis. Odio dictum
        ullamcorper egestas velit velit. Augue eros ullamcorper pulvinar aenean
        mattis. Etiam hac nullam nibh in sollicitudin nullam risus. Sem faucibus
        semper feugiat ut tortor. Aliquam sapien, velit scelerisque magna eget
        malesuada nulla. Varius aliquam morbi a quam id est convallis. Blandit
        ac massa sed felis. Lectus facilisis massa consequat pretium ipsum nibh.
        Dictum blandit habitant quis faucibus duis dui enim. Consequat tristique
        curabitur sed diam vitae enim nunc ridiculus porttitor. In imperdiet
        nullam netus turpis semper tortor. Ac adipiscing varius dolor elementum
        gravida sed. Ipsum et erat euismod sagittis fermentum dignissim. Lacus
        mi odio ipsum, eu posuere magna morbi malesuada. Gravida in tincidunt eu
        bibendum bibendum. Pulvinar ipsum, tellus velit suspendisse ultrices.
        Aliquet id lacus sed gravida condimentum augue arcu, cursus mauris.
        Velit cras id lectus ac neque. Nisi venenatis at in consequat rutrum
        viverra malesuada mattis. Quis semper cras sit massa vitae lacus. A sed
        risus fringilla tortor. Dui nunc cursus sit vel magna. Quis volutpat sit
        ac auctor. Vel proin turpis porttitor amet, nibh. Congue tincidunt
        fringilla sit consectetur. Purus proin et quam volutpat eget sit ut
        nisl. Quis erat nisi mauris dui sed mi commodo semper facilisis. Feugiat
        duis aliquet ultricies mattis at at purus sed. Sed sit augue ac
        tristique quisque augue. Nulla fames eu duis velit sit sed. Pulvinar
        iaculis tellus posuere ut massa a feugiat eget dui. Pellentesque
        suspendisse maecenas eu porttitor sollicitudin urna. Magna diam feugiat
        faucibus facilisis quis neque sollicitudin amet. Ornare enim donec eu ac
        egestas aliquet ultricies. Morbi at quisque velit in porttitor urna est.
        In vulputate nascetur orci neque in malesuada. Nec mattis sapien nunc
        vitae nulla ac, semper commodo tristique. Ut id tellus odio ultricies.
        Sit id sagittis, convallis purus amet risus, iaculis vitae. Ac, proin
        tristique sed placerat nunc. Mattis aliquet ut pellentesque purus
        mattis. Ornare ut praesent quis cursus pellentesque justo, in platea.
        Velit consequat, aliquam tempus, feugiat volutpat nisl, leo. Mauris, ut
        risus aliquam pellentesque. Duis sapien sodales feugiat posuere amet.
        Praesent elit et id mi pellentesque proin risus a mattis. Feugiat mattis
        et aliquet fermentum eleifend aliquam. Dictum porttitor ac ac tincidunt.
        Ut id viverra ut pellentesque purus volutpat morbi pulvinar netus. Magna
        viverra id placerat fringilla. Urna dictum diam commodo, accumsan ornare
        interdum. Turpis tortor vestibulum convallis est nunc orci nunc
        fermentum donec. Maecenas mi sed at consectetur penatibus faucibus at
        eget. Ac nunc tortor egestas viverra lobortis at augue elit risus. Leo
        morbi risus sed faucibus augue accumsan. Scelerisque lacus non a viverra
        pretium proin ut ligula eleifend. Nullam risus, vitae, morbi quis. Cras
        et urna, sit sagittis. Etiam lorem tellus varius orci volutpat montes,
        purus integer. Ultrices eu diam risus vulputate dolor. Dolor
        pellentesque dignissim malesuada mattis amet quam interdum iaculis. Sed
        tincidunt aliquet aliquet cursus netus feugiat. Auctor lobortis feugiat
        fringilla vitae euismod. Amet mauris mollis eget vulputate volutpat et,
        id praesent ut. In amet sagittis nisi libero lacus mauris elit quam
        cursus.
      </p>
    </div>
  </div>
);

function Privacy() {
  return (
    <Fragment>
      <Header />
      <Body />
      <Footer />
    </Fragment>
  );
}

export default Privacy;
